var _style, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Stroke",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#0F0E0E;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "StrokeOne",
    className: "st0",
    points: "10.5,5 21.5,16 10.5,27 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlackIcon);
export default __webpack_public_path__ + "static/media/ArrowRightBlackIcon.ec06ec347155de99baa3a941653a253e.svg";
export { ForwardRef as ReactComponent };